import {FC} from 'react';
import {getPostInnFlowConfig, RegistrationWorkStatus} from '../../model';
import {MyTaxQrBlock} from '../components/MyTaxQrBlock/MyTaxQrBlock';
import {StepLayout} from 'features/registration';

type Props = {
	workStatus: RegistrationWorkStatus | null;
	selfEmploymentProvider?: string | null;
};

export const MyTaxAccessStep: FC<Props> = ({workStatus, selfEmploymentProvider}) => {
	const config = getPostInnFlowConfig(workStatus, {selfEmploymentProvider});

	if (!config.access) {
		return null;
	}

	return (
		<StepLayout variant="fill">
			<StepLayout.Intro title={config.access.title} subtitle={config.access.description} />

			<StepLayout.Content>
				<MyTaxQrBlock />
			</StepLayout.Content>
		</StepLayout>
	);
};
